import React from 'react';
import { Icon } from 'components';
import { H2, Section, Box, Text, Span, RowBox } from 'styles';

export function Section10({ onClick }) {
  const handleLink = () => {
    window.open('https://pf.kakao.com/_PbxexcG', '_blank');
  };

  return (
    <Section $backgroundColor="gray50" $scrollMarginTop={91} $mScrollMarginTop={107}>
      <H2 $display="none">카카오톡 채널</H2>
      <Box $maxWidth={1600} $padding="80px 40px" $mPadding="40px 20px" $margin="auto">
        <Text $type="b40" $mType="b20" $padding="8px 0" $textAlign="center" style={{color: '#3A1D00'}}>
          카카오톡 채널로 추가하는 방법
        </Text>
        <Text $type="18" $mType="14" $textAlign="center" >
          N-Survey 카카오톡 채널을 추가하고 빠른 상담을 받아보세요
        </Text>
        <Box $margin="auto" $width="fit-content" $padding="36px 0" $mPadding="18px 0" $maxWidth={1600}>
          <Icon name="BtnKakao" onClick={handleLink} style={{ cursor: 'pointer' }} />
        </Box>
      </Box>
    </Section>
  );
}